<template>
  <component :is="headingTag" class="decoration-sub-title--small">
    {{ text }}
  </component>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    headingLevel: {
      type: Number,
      required: false,
      default: 4
    }
  },
  computed: {
    headingTag() {
      return `h${this.headingLevel}`
    }
  }
}
</script>
<style lang="scss" scoped>
.decoration-sub-title--small {
  width: 100%;
  border-left: 2px solid $primary;
  padding-left: 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
}
</style>
